export default __webpack_public_path__ + "static/media/frigo.c56c94c0.png";